export default "__VITE_ASSET__517a907b__"